import { useLanguageContext } from '@/lib/LanguageContext';
import { useConfig } from '@/hooks/useConfig';
import { useEffect } from 'react';
import { normalizeLanguageCode } from '@/lib/language';
export const useLanguage = () => {
    const languageContext = useLanguageContext();
    const config = useConfig();
    useEffect(() => {
        if (config.languages && config.languages.length > 0 && !languageContext.isInitialized) {
            languageContext.initializeLanguages(config.languages, 'en');
        }
    }, [config.languages, languageContext.isInitialized, languageContext.initializeLanguages]);
    return {
        currentLanguage: languageContext.currentLanguage,
        availableLanguages: languageContext.availableLanguages,
        isInitialized: languageContext.isInitialized,
        setLanguage: languageContext.setLanguage,
        getCurrentLanguageConfig: languageContext.getCurrentLanguageConfig,
        getLanguageByCode: languageContext.getLanguageByCode,
        isLanguageAvailable: (code) => {
            const normalizedCode = normalizeLanguageCode(code);
            if (!normalizedCode) {
                return false;
            }
            return languageContext.availableLanguages.some(lang => lang.isoCode === normalizedCode);
        },
        getCurrentLanguageName: () => {
            const currentConfig = languageContext.getCurrentLanguageConfig();
            return currentConfig?.caption || languageContext.currentLanguage.toUpperCase();
        },
        resetLanguage: languageContext.resetLanguage,
    };
};
